import React from "react";

import type {RouterLocation, StaticImplementation} from "@client/gotterdammerung";
import {Reports} from "@client/scenes/Reports";
import {ManagerLayout, ManagerTabs} from "@client/site/ManagerLayout";
import {useSiteContext} from "@client/site/context";
import {server} from "@reactivated";

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

type ExtractProps<T> =
    T extends StaticImplementation<any, unknown, infer U, unknown, string[]>
        ? {resolved: U} & T["_routeHooksUsedOnlyForTyping"]
        : never;

function Tabs<
    T extends StaticImplementation<any, unknown, unknown, unknown, string[]>,
>(props: {
    scene: T;
    profile: server.core.rpc.Profile.output;
    resolved: ExtractProps<T>["resolved"];
}) {
    const context = useSiteContext();
    const tabs = Object.keys(props.scene.tabs);
    const location: RouterLocation = {
        pathname: context.request.url,
        locator: null as any,
        query: new URLSearchParams(context.request.url),
    };

    const localHooks: any = props.scene.hooks({
        location,
        resolved: props.resolved,
    });

    const allProps: ExtractProps<typeof Reports> = {
        deviceUUID: "",
        resolved: props.resolved,
        analytics: null as any,
        profile: props.profile,
        useSelector: null as any,
        currentlyManagedUserId: null as any,
        dispatch: null as any,
        notify: null as any,
        platform: null,
    };

    const managerTabs = (
        <ManagerTabs
            contentClassName="pt-2"
            tabs={tabs.map((tab) => {
                const Component = props.scene.tabs[tab].component;

                return {
                    name: tab,
                    title: props.scene.tabs[tab].extra.title,
                    content: <Component {...allProps} {...localHooks} />,
                    icon: props.scene.tabs[tab].extra.icon,
                };
            })}
        />
    );
    return managerTabs;
}

/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-unsafe-assignment */

export const Template = (props: server.manager.templates.ClientManagerReports) => {
    const resolved = {
        authenticated: false as const,
        reports: {
            resolvedThing: "blah",
        },
    };

    return (
        <ManagerLayout title="Reports" currentClientManagerId={props.client_manager.id}>
            <Tabs scene={Reports} profile={props.profile} resolved={resolved} />
        </ManagerLayout>
    );
};
